const state = {
    profile_loaded: false,
    profile: {},
    owner: null,
    driver: null,
    vehicle: null,
    owners: [],
    drivers: [],
    vehicles: []
};

const actions = {
    setProfileLoaded({commit}, status) {
        commit('ProfileLoaded', status);
    },
    setProfile({commit}, data){
        commit('Profile', data);
    },
    setOwner({commit}, data) {
        commit('Owner', data);
    },
    setDriver({commit}, data) {
        commit('Driver', data);
    },
    setVehicle({commit}, data) {
        commit('Vehicle', data);
    },
    setOwners({commit}, data) {
        commit('Owners', data);
    },
    setDrivers({commit}, data) {
        commit('Drivers', data);
    },
    setVehicles({commit}, data) {
        commit('Vehicles', data);
    },
};

const getters = {
    profileLoaded: state => {
        return state.profile_loaded;
    },
    profileData: state => {
      return state.profile;
    },
    ownerData: state => {
        return state.owner ? state.owner : null;
    },
    driverData: state => {
        return state.driver ? state.driver : null;
    },
    vehicleData: state => {
        return state.vehicle ? state.vehicle : null;
    },
    ownersData: state => {
        return state.owners ? state.owners : [];
    },
    driversData: state => {
        return state.drivers ? state.drivers : [];
    },
    vehiclesData: state => {
        return state.vehicles ? state.vehicles : [];
    },
}

const mutations = {
    ProfileLoaded(state, status){
        state.profile_loaded = status;
    },
    Profile(state, data){
      state.profile = data;
    },
    Owner(state, data) {
        state.owner = data;
    },
    Driver(state, data) {
        state.driver = data;
    },
    Vehicle(state, data) {
        state.vehicle = data;
    },
    Owners(state, data) {
        state.owners = data;
    },
    Drivers(state, data) {
        state.drivers = data;
    },
    Vehicles(state, data) {
        state.vehicles = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};